import init from '../../common/base/init';
import A11yDialog from 'a11y-dialog';

init(() => {
  const el = document.getElementById('login-modal');
  if(!el) return;

  const dialog = new A11yDialog(el);
  dialog.show();
});
